import { isFunction, defaults, isCubicBezier, progress } from '@motionone/utils';
import { supports } from './feature-detection.es.js'; // Create a linear easing point for every x second

const resolution = 0.015;

const generateLinearEasingPoints = (easing, duration) => {
  let points = "";
  const numPoints = Math.round(duration / resolution);

  for (let i = 0; i < numPoints; i++) {
    points += easing(progress(0, numPoints - 1, i)) + ", ";
  }

  return points.substring(0, points.length - 2);
};

const convertEasing = (easing, duration) => {
  if (isFunction(easing)) {
    return supports.linearEasing() ? "linear(".concat(generateLinearEasingPoints(easing, duration), ")") : defaults.easing;
  } else {
    return isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
  }
};

const cubicBezierAsString = _ref => {
  let [a, b, c, d] = _ref;
  return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};

export { convertEasing, cubicBezierAsString, generateLinearEasingPoints };